import { TodayContent } from "./Today";

export const Dashboard = () => <TodayContent />;
